<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.isOnsale" @tab-click="handleFilter">
          <el-tab-pane label="出售中的商品" name="1" />
          <el-tab-pane label="仓库中的商品" name="0" />
        </el-tabs>

        <el-row :gutter="20" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.goodsName" class="filter-item" placeholder="商品名称" />
          </el-col>
          <el-col :xs="24" :sm="3">
            <el-select v-model="queryParams.userGrade" class="filter-item" placeholder="用户身份" clearable>
              <el-option label="VIP" :value="2">
                <span style="float: left;">普通会员</span>
                <span style="float: right; color: #8492a6; font-size: 13px;">VIP</span>
              </el-option>
              <el-option label="SVIP" :value="3">
                <span style="float: left;">超级会员</span>
                <span style="float: right; color: #8492a6; font-size: 13px;">SVIP</span>
              </el-option>
            </el-select>
          </el-col>
          <!-- el-col :xs="24" :sm="3">
            <el-select v-model="queryParams.giftType" class="filter-item" placeholder="礼包类型" clearable>
              <el-option label="身份礼包" :value="0" />
              <el-option label="收益礼包" :value="1" />
            </el-select>
          </el-col -->
          <el-col :xs="24" :sm="6">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button class="filter-item" style="margin-left: 10px;" type="danger" icon="el-icon-edit" @click="handleCreate">上架商品</el-button>
          </el-col>
        </el-row>
      </template>

      <gift-table ref="giftTable" :params="options" :loading.sync="loading" @delete="handleRemove" />
    </el-card>
  </div>
</template>

<script>
import { deleteGoods } from '@/api/goods'
import GiftTable from '../components/GiftTable'

export default {
  name: 'GiftList',
  components: { GiftTable },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        referred: 'backend',
        mallType: '4', // 特权礼包
        goodsName: undefined,
        userGrade: undefined,
        giftType: undefined,
        isOnsale: '1',
        page: 1,
        limit: 20
      },
      options: {}
    }
  },
  created() {
    console.log('created - 组件创建')
    this.options = Object.assign({}, this.queryParams)
  },
  activated() {
    console.log('activated - 缓存生效了')
  },
  deactivated() {
    console.log('deactivated - 已缓存')
  },
  methods: {
    handleFilter() {
      this.options = Object.assign({}, this.queryParams)
    },
    formatMoney(money) {
      return this.$util.formatNumber(money)
    },
    handleCreate() {
      this.$router.push({ path: '/goods/gift/create', query: { from: 'list' }})
    },
    handleRemove(e) {
      this.$confirm(`确定要删除商品【${e.name}】吗？`, '删除提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        const params = Object.assign({}, this.queryParams, { id: e.value })
        if (params.page * params.limit >= this.$refs.giftTable.total) params.page = 1

        deleteGoods(params).then(response => {
          this.queryParams = Object.assign({}, params)
          this.options = Object.assign({}, this.queryParams)
          // this.list = response.records
          // this.total = response.total
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          setTimeout(() => { this.loading = false }, 500)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-tag {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .el-tag {
    display: block;
    width: 100%;
    + .el-tag {
      margin-top: 8px;
    }
  }
}
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
</style>
